"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPrintingGuides = exports.setIncludeBuffer = exports.setDrawBorder = exports.setBackgroundColor = void 0;
const immer_1 = require("immer");
const typedLocalStorage_1 = require("../../../lib/browser/typedLocalStorage");
const localItem = (0, typedLocalStorage_1.LocalItem)("mapmaker.rectangularPrintOptions", 1);
const SET_OPTIONS = "print_options.set_options";
function setBackgroundColor(value) {
    return {
        type: SET_OPTIONS,
        options: {
            backgroundColor: value,
        },
    };
}
exports.setBackgroundColor = setBackgroundColor;
function setDrawBorder(value) {
    return {
        type: SET_OPTIONS,
        options: {
            borderWidth: value ? 2 : 0,
        },
    };
}
exports.setDrawBorder = setDrawBorder;
function setIncludeBuffer(value) {
    return {
        type: SET_OPTIONS,
        options: {
            includeBuffer: value,
        },
    };
}
exports.setIncludeBuffer = setIncludeBuffer;
function setPrintingGuides(value) {
    return {
        type: SET_OPTIONS,
        options: {
            printingGuides: value,
        },
    };
}
exports.setPrintingGuides = setPrintingGuides;
const initialState = {
    backgroundColor: "#FFFFFF",
    borderColor: "#000000",
    borderWidth: 2,
    clipImage: true,
    includeBuffer: true,
    printingGuides: false,
};
function createPrintOptionsReducer(allowBufferArea = true) {
    return (0, immer_1.produce)((draft, action) => {
        if (draft === undefined) {
            const localOptions = localItem.get();
            const initial = localOptions || Object.assign(Object.assign({}, initialState), { includeBuffer: allowBufferArea });
            if (!allowBufferArea) {
                initial.includeBuffer = false;
            }
            return initial;
        }
        switch (action.type) {
            case SET_OPTIONS:
                Object.keys(action.options).forEach((key) => {
                    draft[key] = action.options[key];
                });
                localItem.put(draft);
                break;
            default:
                break;
        }
    });
}
exports.default = createPrintOptionsReducer;
//# sourceMappingURL=data:application/json;base64,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